import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import { evaluate } from 'mathjs';

interface CalculationInputProps {
  value: number | string;
  onChange: (value: number) => void;
  disabled?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
}

const CalculationInput: React.FC<CalculationInputProps> = ({
  value,
  onChange,
  disabled,
  placeholder = 'e.g. 5+5+5*2/1',
  style,
}) => {
  const [input, setInput] = useState<string>(String(value ?? ''));
  const [error, setError] = useState<string>('');

  useEffect(() => {
    setInput(String(value ?? ''));
  }, [value]);

  const handleBlur = () => {
    try {
      if (input.trim() === '') {
        onChange(0);
        setError('');
        return;
      }
      const result = evaluate(input);
      if (typeof result === 'number' && !isNaN(result)) {
        onChange(result);
        setError('');
      } else {
        setError('Invalid');
      }
    } catch {
      setError('Invalid');
    }
  };

  return (
    <Input
      value={input}
      disabled={disabled}
      onChange={e => {
        setInput(e.target.value);
        setError('');
      }}
      onBlur={handleBlur}
      status={error ? 'error' : undefined}
      placeholder={placeholder}
      style={style}
    />
  );
};

export default CalculationInput;
